/**
 * App shell wrapper. SSO session establishment uses full-page redirect with
 * a one-time code (?code=) — never session tokens in the URL.
 */
export default function SsoSessionBootstrap({ children }) {
    return children
}
